export default {
  methods: {
    message(config) {
      this.$swal.fire({
        text: 'Invalid data',
        toast: true,
        position: 'bottom-right',
        showConfirmButton: false,
        timer: 3000,
        animation: false,
        ...config,
      });
    },
    successMessage(text) {
      this.message({
        background: '#77a734',
        title: '<i class="far fa-check fa-lg"></i>',
        text,
      });
    },
    warningMessage(text) {
      this.message({
        background: '#fc861e',
        title: '<i class="far fa-exclamation-circle"></i>',
        text,
      });
    },
    errorMessage(text) {
      this.message({
        background: '#d91b1b',
        title: '<i class="far fa-debug fa-lg"></i>',
        text,
      });
    },
  },
};
